// src/components/footer/Footer.js
import './Footer.css';
import logomain from '../../images/applogo.svg';
import vkIcon from '../../images/vk.svg';
import tgIcon from '../../images/tg.svg';
import ttIcon from '../../images/tt.svg';
import siteIcon from '../../images/site.svg';
import waIcon from '../../images/wa.svg';
import supportIcon from '../../images/support.svg';

function Footer() {
    return (
        <div className="FooterApp">
            {/* Внутренний «центровщик» */}
            <div className="footerContent">
                <div className="logoColumn">
                    <img src={logomain} alt="Логотип" />
                </div>

                <div className="socialIcons">
                    <a href="https://t.me/sergiovalor" target="_blank" rel="noopener noreferrer">
                        <img src={siteIcon} alt="Site" className="socialIcon" />
                    </a>
                    <a href="https://t.me/sergiovalor" target="_blank" rel="noopener noreferrer">
                        <img src={tgIcon} alt="Telegram" className="socialIcon" />
                    </a>
                    <a href="https://t.me/sergiovalor" target="_blank" rel="noopener noreferrer">
                        <img src={ttIcon} alt="TikTok" className="socialIcon" />
                    </a>
                    <a href="http://wa.me/79259992470" target="_blank" rel="noopener noreferrer">
                        <img src={waIcon} alt="WhatsApp" className="socialIcon" />
                    </a>
                    <a href="https://t.me/sergiovalor" target="_blank" rel="noopener noreferrer">
                        <img src={vkIcon} alt="VK" className="socialIcon" />
                    </a>
                </div>

                <div className="supportBlock">
                  <a
                    href="https://t.me/sergiovalor"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="supportLink">
                    <img src={supportIcon} alt="Support" className="supportIcon" />
                    <span className="supportText">Support</span>
                    </a>
                </div>
                <div className="legalInfo">
                    <a href="/main" className="footerLink">Пользовательское соглашение</a>
                    <a href="/main" className="footerLink">Политика конфиденциальности</a>
                </div>
            </div>
        </div>
    );
}

export default Footer;
